(function() {
  var Base,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Base = App.loadClass('grower::Angular/Operation/Machinery/BaseMachineryController');

  exports.ModalMachineryController = (function(superClass) {
    extend(ModalMachineryController, superClass);

    function ModalMachineryController(scope, transitions, modal, modalInstance, machineryService, q, viewing, editing, id, typeId, autoSelect) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.modalInstance = modalInstance;
      this.machineryService = machineryService;
      this.q = q;
      this.viewing = viewing;
      this.editing = editing;
      ModalMachineryController.__super__.constructor.call(this, this.scope, this.transitions, this.modal, this.machineryService, this.q, this.viewing, this.editing, id, typeId);
      if (autoSelect.type) {
        this.machineryService.getType(autoSelect.type).then((function(_this) {
          return function(type) {
            _this.machinery.type = type;
            return _this.loadFormData().then(function() {
              var cropCategory;
              if (autoSelect.crop) {
                cropCategory = (function() {
                  switch (autoSelect.crop.name) {
                    case 'Corn':
                    case 'Corn Silage':
                    case 'Popcorn':
                      return 'Corn';
                    case 'Alfalfa':
                    case 'Millet':
                    case 'Sorghum':
                    case 'Wheat':
                      return 'Small Grains';
                    default:
                      return autoSelect.crop.name;
                  }
                })();
                return _this.machinery.crop = _this.formData.crops.find(function(crop) {
                  return crop.name === cropCategory;
                });
              }
            });
          };
        })(this));
      }
    }

    ModalMachineryController.prototype.save = function() {
      this.setAlert({
        msg: 'Saving machinery...',
        type: 'info'
      });
      return this.machineryService.save(this.machinery).then((function(_this) {
        return function(machine) {
          _this.setAlert({
            msg: _this.machinery.type.name + " saved!",
            type: 'success'
          });
          return _this.modalInstance.close(machine);
        };
      })(this))["catch"]((function(_this) {
        return function(error) {
          return _this.setAlert({
            msg: error,
            type: 'error'
          });
        };
      })(this));
    };

    ModalMachineryController.prototype.cancel = function() {
      return this.modalInstance.dismiss('cancel machinery');
    };

    return ModalMachineryController;

  })(Base);

}).call(this);
